import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConfig } from './config/api.config';
import { ConsultaLista } from '../models/consulta-lista.model';
import { DataContract } from '../models/data-contract.model';
import { User } from '../models/user.model';

@Injectable()
export class ContractService{   

    constructor(
        private http: HttpClient,
        private api: ApiConfig,     
    ){}  

    postContracts(consulta : ConsultaLista) : Observable<Array<any>> {
        return this.http.post<Array<any>>(this.api.url + '/contracts/', consulta);
    }

    getDataContract(contract : string): Observable<DataContract> {
        return this.http.get<DataContract>(this.api.url + '/contracts/' + contract);
    }

    getValidaExistente(contract : string, identificacion : string) : Observable<boolean>{
        return this.http.get<boolean>(this.api.url + '/contracts/_public/' + contract + '/' + identificacion);
    }

    postConsultaUsuarioRegistradoContrato(user : User) : Observable<boolean>{
        return this.http.post<boolean>(this.api.url + '/contracts/_public/user/', user);
    }

    getValidateContract(contract : string, identificacion : string) : Observable<boolean>{
        return this.http.get<boolean>(this.api.url + '/contracts/_public/validate/' + contract + '/' + identificacion);
    }

}


// WEBPACK FOOTER //
// /app/src/app/shared/services/contract.service.ts